import Exam from '@/models/Exam';
import { Feedback, FeedbackCreateDTO } from '@/models/Feedback';
import { Model, Nullable } from '@/models/Model';
import User from '@/models/User';

export enum StudentExamCorrectionStatusEnum {
  PENDING = 'PENDING',
  CORRECTED = 'CORRECTED',
}

export type StudentExamStudent = Pick<
  User,
  'id' | 'firstName' | 'lastName' | 'username'
>;

export type StudentExamActivityProgressRef = {
  id: number;
  activityId: number;
};

export default interface StudentExam extends Model {
  exam: Exam;
  student: StudentExamStudent;
  klassId: number;
  activitiesProgresses: StudentExamActivityProgressRef[];
  opensAt: string;
  closesAt: string;
  maxTime: number;
  timeSpent: Nullable<number>;
  grade: Nullable<number>;
  maxGrade: Nullable<number>;
  feedbacks: Feedback[];
  finishedAt: Nullable<string>;
  correctedAt: Nullable<string>;
  lastCorrectedById: Nullable<number>;
}

export type StudentExamCorrectionDTO = {
  feedbacks: FeedbackCreateDTO[];
};
